import { useFieldError } from '~/components/FormContext'

type SelectProps = {
  name: string
  label: string
  options: Option[]
}

type Option = {
  value: string
  text: string
}

export const Select = ({ name, label, options }: SelectProps) => {
  const error = useFieldError(name)

  return (
    <div className="mb-5 mr-4 w-full sm:w-2/5 xl:w-[48%] print:mb-2 print:w-[44%]">
      <label htmlFor={name} className="block">
        <span className="text-gray-700">{label}</span>
        <select
          id={name}
          name={name}
          className="focus:border-primary-grey peer mt-1 w-full rounded bg-white focus:outline-none print:p-2 print:text-sm"
        >
          <option value="" hidden>
            Please Choose...
          </option>
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.text}
            </option>
          ))}
        </select>
        {error && <p className="font-bold text-red-900">{error}</p>}
      </label>
    </div>
  )
}
